<template>
  <div>
    <div class="flex items-center px-4 py-4 flex-wrap">
      <div class="w-6/12">
        {{ header }}
      </div>
      <div class="w-6/12 justify-end flex"></div>
    </div>

    <div class="w-full flex justify-center py-6 relative">
      <div class="middle-text">
        <div class="w-auto text-center inner-content">
          <b class="w-full block">₦ {{ totalValue }}</b>
          <span class="w-full block opacity-50">Total</span>
        </div>
      </div>
      <apexchart
        type="donut"
        width="380"
        :options="chartOptions"
        :series="series"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: { type: String },
    paymentStatus: { type: Object },
  },


  computed: {
    // series values for donut chart
    series() {
      if (!this.paymentStatus) return [0, 0, 0];
      return [
        this.paymentStatus.paid || 0,
        this.paymentStatus.pending || 0,
        this.paymentStatus.refunded || 0,
      ];
    },

    // labels
    labels() {
      return ["Paid", "Pending Payments", "Refunded"];
    },

    // total value formatter
    totalValue() {
      if (!this.paymentStatus || this.paymentStatus.total == null) return "0.00";
      const formatter = new Intl.NumberFormat("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(Number(this.paymentStatus.total));
    },

    // chart options
    chartOptions() {
      return {
        chart: {
          width: 380,
          type: "donut",
        },
        colors: ["#09B78A", "#FFA600", "#D72638"], // Green for Paid, Dark for Pending, Red for Refunded
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          pie: {
            donut: {
              size: "70%",
              labels: {
                show: true,
                name: { show: false },
                value: { show: false },
                total: {
                  show: true,
                  label: "Total",
                  formatter: () => this.totalValue,
                },
              },
            },
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: { width: 200 },
              legend: { show: false },
            },
          },
        ],
        legend: {
          show: false,
          // position: "bottom",
        },
        labels: this.labels,
      };
    },
  },
};
</script>


<style lang="scss" scoped>
.middle-text {
  @apply absolute w-full h-full top-0 left-0 flex justify-center items-center;
}

.inner-content {
  @apply relative;
  top: -16px;
}
</style>
